import type { JSX } from "react";
import { Link } from "react-router-dom";

/**
 * The homepage's 72→112px accent-bar CTA, reused at every guide callsite —
 * `.atlas-cta` already owns the hover/focus motion, the 44px target height and
 * the focus ring. `href` opens off-site (Instagram); `to` is an in-site route.
 */
export function AtlasCta({
  href,
  to,
  label,
}: {
  href?: string;
  to?: string;
  label: string;
}): JSX.Element {
  const body = (
    <>
      <span className="atlas-cta-bar" aria-hidden="true" />
      <span className="atlas-cta-label">{label}</span>
    </>
  );
  return href ? (
    <a className="atlas-cta" href={href} target="_blank" rel="noreferrer">
      {body}
    </a>
  ) : (
    <Link className="atlas-cta" to={to ?? "/"}>
      {body}
    </Link>
  );
}
